import React, { useState, useEffect, useRef } from 'react';
import { db, collection, addDoc } from '../LoginComp/firebase';
import './feedback.css';

function Feedback() {
  const [isOpen, setIsOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState(""); // State to track the feedback input
  const [loading, setLoading] = useState(false); // Loading state
  const feedbackFormRef = useRef(null); // FIX: Define the ref here

  const toggleFeedbackForm = () => {
    setIsOpen(!isOpen);
  };

  // Handle feedback submission
  const handleSubmit = async () => {
    if (!feedbackText) {
      alert("Please enter your feedback");
      return;
    }
    
    try {
      setLoading(true);
      // Add the feedback to Firestore
      await addDoc(collection(db, 'feedbacks'), {
        feedback: feedbackText,
        timestamp: new Date(),
      });
      setFeedbackText(""); // Clear the input field after submission
      alert("Thank you for your feedback!");
      setIsOpen(false); // Close the feedback form
    } catch (error) {
      console.error("Error adding feedback: ", error);
      alert("There was an error submitting your feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Close feedback form if the user clicks outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        feedbackFormRef.current &&
        !feedbackFormRef.current.contains(event.target) &&
        !event.target.closest('.feedback-button')
      ) {
        setIsOpen(false); // Close the form if the user clicks outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="body">
      <div className={`feedback-button ${isOpen ? "open" : ""}`} onClick={toggleFeedbackForm}>
        <div className="shine"></div>
        <span>Feedback</span>
      </div>

      {isOpen && (
        <div className="feedback-form" ref={feedbackFormRef}>
          <div className="column">
            <textarea
              placeholder="Your feedback..."
              rows="4"
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
            />
          </div>
          <div className="column">
            <button className="submit-button" onClick={handleSubmit} disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Feedback;


